module.exports = __webpack_public_path__ + "static/media/blender-phone.a5eb6646.svg";